export class FrustumCulling {
    static cullingRenderBounds(bounds, cullInfo) {
        var cullPlaneCount = cullInfo.cullPlaneCount;
        var cullPlanes = cullInfo.cullPlanes;
        var min = bounds._imp.getMin();
        var max = bounds._imp.getMax();
        var minX = min.x;
        var minY = min.y;
        var minZ = min.z;
        var maxX = max.x;
        var maxY = max.y;
        var maxZ = max.z;
        var pass = true;
        for (var j = 0; j < cullPlaneCount; j++) {
            var plane = cullPlanes[j];
            var normal = plane.normal;
            if (plane.distance + (normal.x * (normal.x < 0.0 ? minX : maxX)) + (normal.y * (normal.y < 0.0 ? minY : maxY)) + (normal.z * (normal.z < 0.0 ? minZ : maxZ)) < 0.0) {
                pass = false;
                break;
            }
        }
        return pass;
    }
}
